import { takeLatest, call, put } from "redux-saga/effects";
import {
  ADD_GCP_ACCOUNT,
  ADD_GCP_ACCOUNT_SUCCESS,
  ADD_GCP_ACCOUNT_ERROR,
} from "./gcpActions";
import { addGCPAccountApi } from "./gcpApi";

function* AddGCPAccount(params) {
  try {
    const data = yield call(addGCPAccountApi, params.params);
    yield put({ type: ADD_GCP_ACCOUNT_SUCCESS, data });
  } catch (error) {
    yield put({ type: ADD_GCP_ACCOUNT_ERROR, error });
  }
}

export function* manageGCPAccountSaga() {
  yield takeLatest(ADD_GCP_ACCOUNT, AddGCPAccount);
}
